import React from 'react';

import {
  Sidebar as ShadcnSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from '@/components/ui/sidebar';
import NavLinks from './NavLinks';
import UserSelect from './UserSelect';
import WorkspaceSelect from './WorkspaceSelect';

const Sidebar = () => (
  <ShadcnSidebar collapsible="icon" variant="inset">
    <SidebarHeader className="p-1">
      <WorkspaceSelect />
    </SidebarHeader>

    <SidebarContent>
      <NavLinks />
    </SidebarContent>

    <SidebarFooter className="p-1">
      <UserSelect />
    </SidebarFooter>
  </ShadcnSidebar>
);

export default Sidebar;
